import { gql } from '@apollo/client';

export const ALL_PROVINCES = gql`
  query AllProvinces($input: FilterProvinceInput!) {
    provinces: getProvinces(input: $input) {
      id
      name
    }
  }
`;
